// extracted by mini-css-extract-plugin
export default {"popconfirm":"styles_popconfirm__GgMkb","button":"styles_button__AoKnR","ant-btn-disabled":"styles_ant-btn-disabled__ZNtUz","custom-button":"styles_custom-button__CJpzd"};